import React, { useEffect, useState } from "react";
import "../../styles/banner.css";

const Banner = () => {
  const [cvaiPrice, setCvaiPrice] = useState(null);

  // AOS is initialized in Home.js, no need to init here

  useEffect(() => {
    // Fetch CVAI price from DexScreener API
    const fetchCvaiPrice = async () => {
      try {
        const tokenAddress = "8TC4ZJA5cwB5gmLemBfPP95v1Mft82kHGF9a87kepNno";
        const response = await fetch(
          `https://api.dexscreener.com/latest/dex/tokens/${tokenAddress}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch price");
        }

        const data = await response.json();

        // Find the pair with highest liquidity (usually the main trading pair)
        if (data.pairs && data.pairs.length > 0) {
          const mainPair = data.pairs[0];
          const priceUsd = parseFloat(mainPair.priceUsd);

          if (priceUsd && !isNaN(priceUsd)) {
            // Format price: if less than 0.01, show more decimals
            if (priceUsd < 0.01) {
              setCvaiPrice(`$${priceUsd.toFixed(6)}`);
            } else if (priceUsd < 1) {
              setCvaiPrice(`$${priceUsd.toFixed(4)}`);
            } else {
              setCvaiPrice(`$${priceUsd.toFixed(2)}`);
            }
            return;
          }
        }

        throw new Error("No price data found");
      } catch (error) {
        console.error("Error fetching CVAI price:", error);
        // If API fails, we'll hide the price section
      }
    };

    fetchCvaiPrice();

    // Refresh price every 30 seconds
    const interval = setInterval(fetchCvaiPrice, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="banner">
      <div className="shape right"></div>
      <div className="container big">
        <div className="row">
          <div className="col-xl-6 col-md-12">
            <div className="banner__left">
              <div className="block-text">
                <h2 className="heading">
                  CVMech NFT - Free Mint But Real Value
                </h2>
                <p className="desc">
                  CVMech is the key access for holders to the vault of $10k+
                  thru ecosystem!
                </p>
                <a
                  href="https://raydium.io/swap/?inputMint=sol&outputMint=8TC4ZJA5cwB5gmLemBfPP95v1Mft82kHGF9a87kepNno"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="action-btn"
                >
                  <span>Get Your $CVAI</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-md-12">
            <div className="banner__right">
              <div className="image">
                <img src="/images/layouts/banner.webp" alt="Banner" />
              </div>
              {cvaiPrice && (
                <div className="price">
                  <div className="icon">
                    <img src="/images/icon/icon-01.png" alt="Icon" />
                  </div>
                  <div className="content">
                    <p>$CVAI Price</p>
                    <h5>{cvaiPrice}</h5>
                  </div>
                </div>
              )}
              <div className="owner">
                <div className="image">
                  <img src="/images/layouts/avt-01.png" alt="Owner" />
                </div>
                <div className="content">
                  <h5>CV Pad</h5>
                  <p>@CVPad_io</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
